module.exports = __webpack_public_path__ + "static/img/male.88c042e0.png";